import type { AppEdge, AppNode, AppNodeOf } from '../../flow/types';

export type MazeWorkspaceFrame = {
  functionNodeId: string;
  functionName: string;
  nodes: AppNode[];
  edges: AppEdge[];
};

export const getFunctionWorkspaceFlow = (
  node: AppNodeOf<'function'>,
  createInitialNodes: () => AppNode[],
): { nodes: AppNode[]; edges: AppEdge[] } => (
  node.data.internalNodes.length > 0
    ? { nodes: node.data.internalNodes, edges: node.data.internalEdges }
    : { nodes: createInitialNodes(), edges: [] }
);

export const materializeMazeWorkspace = (
  frames: MazeWorkspaceFrame[],
  activeNodes: AppNode[],
  activeEdges: AppEdge[],
): { nodes: AppNode[]; edges: AppEdge[] } => {
  let childNodes = activeNodes;
  let childEdges = activeEdges;

  for (let index = frames.length - 1; index >= 0; index -= 1) {
    const frame = frames[index];
    childNodes = frame.nodes.map((node) => node.id === frame.functionNodeId && node.type === 'function'
      ? {
          ...node,
          data: { ...node.data, internalNodes: childNodes, internalEdges: childEdges },
        }
      : node) as AppNode[];
    childEdges = frame.edges;
  }

  return { nodes: childNodes, edges: childEdges };
};